export const clamp = (v: number, min: number, max: number) => (v < min ? min : v > max ? max : v);

/** http üzerinden (LAN IP) açıldığında navigator.clipboard yoktur; eski yönteme düşer. */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // aşağıdaki yönteme düş
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}

export function extractLessonId(input: string): string | null {
  const s = input.trim().toLowerCase();
  const fromUrl = /\/ders\/([a-z0-9]{4,20})/.exec(s);
  if (fromUrl) return fromUrl[1];
  return /^[a-z0-9]{4,20}$/.test(s) ? s : null;
}

export function formatDate(ts: number): string {
  return new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' }).format(ts);
}

/** "2 sa 5 dk", "45 dk", "1 dk'dan az"; hiç süre yoksa çizgi. */
export function formatDuration(ms: number): string {
  if (ms <= 0) return '—';
  const minutes = Math.round(ms / 60000);
  if (minutes < 1) return "1 dk'dan az";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h ? (m ? `${h} sa ${m} dk` : `${h} sa`) : `${m} dk`;
}

export function formatWhen(ts: number): string {
  return new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(ts);
}
